import { createContext, useContext } from 'react';
import type { ComponentRegistry, ComponentTypeDefinition } from './registry';
import { builtinChartRegistry } from './builtinCharts';

/**
 * Registry the canvas resolves component types against. Defaults to the
 * builtin charts so single-registry surfaces (the query builder) need no
 * provider; surfaces with extra widgets wrap their canvas in
 * `ComponentRegistryContext.Provider`.
 */
export const ComponentRegistryContext =
  createContext<ComponentRegistry>(builtinChartRegistry);

export function useComponentRegistry(): ComponentRegistry {
  return useContext(ComponentRegistryContext);
}

/** Definition for a component type, or null when it isn't registered. */
export function useComponentDefinition(
  type: string,
): ComponentTypeDefinition | null {
  return useComponentRegistry()[type] ?? null;
}
